import React, { useContext } from 'react';
import { MetadataContext } from '../../context/metadata/metadata.context';
import { useJobsData } from './JobsTbdContainer.hooks';
import { JobsTbdContainerProps } from './JobsTbdContainer.types';
import { Jobs } from './Components/Jobs';

export const JobsTbdContainer = (props: JobsTbdContainerProps) => {
    const { jobsInitialData } = props;
    const { rollouts } = useContext(MetadataContext);
    const jobsFullData = useJobsData(jobsInitialData, rollouts);

    return <Jobs jobsFullData={jobsFullData} />;
};
